import request from './request'

import requestV2 from '../utils/requestV2';


interface LoginForm {
  username: string
  password: string
}

interface RegisterForm {
  username: string
  password: string
  phone?: string
}

interface ResetPasswordForm {
  username: string
  password: string
}

export const login = (data: LoginForm) => {
  return request({
    url: '/auth/login',
    method: 'post',
    data
  })
}

export const register = (data: RegisterForm) => {
  return request({
    url: '/auth/register',
    method: 'post',
    data
  })
}

export const resetPassword = (data: ResetPasswordForm) => {
  return requestV2({
    url: '/system/auth/reset-password',
    method: 'post',
    data
  })
}
